import React from "react";

function TableRow({ data, index }) {
  const isFirst = parseInt(data.ranked) === 1;
  let rankSuffix = "th";
  if (data.ranked % 10 === 1 && data.ranked !== 11) {
    rankSuffix = "st";
  } else if (data.ranked % 10 === 2 && data.ranked !== 12) {
    rankSuffix = "nd";
  } else if (data.ranked % 10 === 3 && data.ranked !== 13) {
    rankSuffix = "rd";
  }

  const itemClassName = `item${isFirst ? "item1" : ""}`;

  return (
    <div className={itemClassName} key={data.user_id}>
    
      <div className="rank_all">
        {" "}
        {data.ranked}
        {rankSuffix}
      </div>
      <div className="img_name">
        <div className="image_">
          <img
            style={{ width: "2rem", height: "2rem", borderRadius: "5rem", marginLeft:"0.2rem" }}
            src={data.profile_picture_url}
            alt={data.display_name}
          />
        </div>
        <div className="name_">{data.display_name.toUpperCase()}</div>
      </div>
      <div className="points_">
        {data.total_points}<span>PTS</span>
      </div>
    </div>
  );
}

export default TableRow;
